import { isCancelledRequest } from 'shared/channels/cancellation';
import { isChannelRequestTimeout } from 'shared/channels/errors';
import { logErrorUnlessNetworkFailure } from './logErrorUnlessNetworkFailure';

/**
 * Logs a failed request to the service worker. A timeout is skipped: the
 * channel layer already reported it once, with diagnostics. So is a request
 * that was cancelled: it did not fail. A request the worker could not send
 * for a lost network is logged as info.
 */
export function logChannelRequestFailure(
  message: string,
  error: unknown,
  context: Record<string, unknown> = {}
): void {
  if (!isChannelRequestTimeout(error) && !isCancelledRequest(error)) {
    logErrorUnlessNetworkFailure(message, error, context);
  }
}
